import React from 'react'
import { LuTrendingUp, LuMousePointerClick, LuFolderKanban, LuBriefcase } from 'react-icons/lu'

const InnovativeCurriculomnData = [
  {
    heading: 'Adaptive Learning',
    para: 'Personalized learning paths based on individual student needs and progress.',
    Icon: LuTrendingUp,
    cls: 'span-3 tone-brand',
  },
  {
    heading: 'Interactive Content',
    para: 'Engaging multimedia elements, simulations, and interactive exercises to enhance learning.',
    Icon: LuMousePointerClick,
    cls: 'span-3',
  },
  {
    heading: 'Project-Based Learning',
    para: 'Real-world projects that apply theoretical knowledge and develop practical skills.',
    Icon: LuFolderKanban,
    cls: 'span-3',
  },
  {
    heading: 'Industry-Specific Modules',
    para: 'Focused curriculum tailored to specific industry sectors and job roles.',
    Icon: LuBriefcase,
    cls: 'span-3 tone-soft',
  },
]

const InnovativeCurriculomn = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Curriculum</span>
      <h2 className='home_heading'>An innovative curriculum built for the evolving needs of industry</h2>
      <p className='home_lead'>Our curriculum is dynamic, engaging, and relevant. We incorporate cutting-edge technologies, innovative teaching methodologies, and real-world case studies to create a rich and interactive learning experience.</p>

      <div className='bento'>
        {InnovativeCurriculomnData.map(({ Icon, heading, para, cls }, index) => (
          <div className={`bento_card ${cls}`} key={index}>
            <Icon className='bento_icon' />
            <h3 className='bento_title'>{heading}</h3>
            <p className='bento_para'>{para}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default InnovativeCurriculomn
